import { usePostgresChangesRealtime } from './usePostgresChangesRealtime';

type Options = {
  enabled?: boolean;
  /** Watch customers and/or items (and optional SKU mappings / versions). */
  include?: Array<
    | 'customers'
    | 'items'
    | 'templates'
    | 'ai_customer_mappings'
    | 'system_config'
    | 'prices'
    | 'standard_sales_lines'
  >;
  onChange?: () => void;
};

/**
 * Live-refresh DEM Customers / Items / SKU map master data.
 * Requires migrations 247 / 268.
 */
export function useDemMasterDataRealtime(options: Options = {}) {
  const {
    enabled = true,
    include = ['customers', 'items'],
    onChange,
  } = options;

  usePostgresChangesRealtime({
    enabled: enabled && include.length > 0,
    channelName: `dem-master-live:${include.join('+')}`,
    portalKind: 'dem',
    syncSecondaryAuth: true,
    debounceMs: 500,
    onChange,
    listens: include.map((table) => ({
      schema: 'data_entry_management',
      table,
    })),
  });
}
